// GA4 e-commerce event helpers — safe no-ops if gtag isn't loaded
const gtag = (...args) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(...args);
  }
};

export const trackAddToCart = ({ id, name, price, quantity = 1, category, currency = "GBP" }) => {
  gtag("event", "add_to_cart", {
    currency,
    value: (parseFloat(price) || 0) * quantity,
    items: [{
      item_id: id || name,
      item_name: name,
      item_category: category,
      price: parseFloat(price) || 0,
      quantity,
    }],
  });
};

export const trackBeginCheckout = (value, itemCount, currency = "GBP") => {
  gtag("event", "begin_checkout", {
    currency,
    value: parseFloat(value) || 0,
    items_count: itemCount,
  });
};

export const trackPurchase = ({ transactionId, value, currency = "GBP" }) => {
  // Dedupe: only fire once per transaction (success page can be refreshed/polled)
  const key = `ga4_purchase_${transactionId}`;
  if (localStorage.getItem(key)) return;
  localStorage.setItem(key, "1");
  gtag("event", "purchase", {
    transaction_id: transactionId,
    currency,
    value: parseFloat(value) || 0,
  });
};
